(function () {
  'use strict';

  angular
    .module('app.directive.account', [])

    .directive('ordersFilter', function () {
      return {
        restrict: 'A',
        require: {
          accountOrderTrackingCtrl: '?^^accountOrderTracking',
          accountReturnsCtrl: '?^^accountReturns'
        },
        bindToController: {
          options: '<'
        },
        controller: function () {
          var ctrl = this;

          ctrl.$onInit = function () {
            var i = 0;
            _.each(ctrl.options, function (option) {
              option.index = i;
              option.caption = _.unescape(option.caption);
              i++;
            });
            var parentCtrl = ctrl.accountOrderTrackingCtrl || ctrl.accountReturnsCtrl;
            parentCtrl.setFilterOptions(ctrl.options);
          };
        }
      };
    });

})();
